import type { ReactNode, RefObject } from 'react'

/** Card de informação dos cabeçalhos de conversa (ocorrência, chamado do
 * HUB): rótulo pequeno e valor; vira botão quando editável. */
export function InfoCard({
  label,
  danger = false,
  onClick,
  actionTitle,
  buttonRef,
  children,
}: {
  label: string
  danger?: boolean
  onClick?: () => void
  /** Dica do card clicável; padrão "Alterar <rótulo>". */
  actionTitle?: string
  buttonRef?: RefObject<HTMLButtonElement>
  children: ReactNode
}) {
  const cls = `min-w-0 rounded-xl border px-4 py-2.5 text-left ${
    danger
      ? 'border-red-200 bg-red-50 dark:border-red-900/60 dark:bg-red-900/20'
      : 'border-border-subtle bg-surface'
  }`
  const body = (
    <>
      <span
        className={`block text-[13px] ${danger ? 'text-red-700 dark:text-red-400' : 'text-muted'}`}
      >
        {label}
      </span>
      <span
        // Texto cortado (nome longo): inteiro no passar do mouse. Card
        // clicável já tem a dica da ação ("Alterar …") — não sobrepõe.
        title={!onClick && typeof children === 'string' ? children : undefined}
        className={`mt-0.5 block truncate text-[16px] font-semibold ${
          danger ? 'text-red-700 dark:text-red-400' : 'text-body'
        }`}
      >
        {children}
      </span>
    </>
  )
  if (!onClick) return <div className={cls}>{body}</div>
  return (
    <button
      ref={buttonRef}
      type="button"
      onClick={onClick}
      title={actionTitle ?? `Alterar ${label.split(' ·')[0].toLowerCase()}`}
      className={`${cls} transition hover:border-border-strong`}
    >
      {body}
    </button>
  )
}
